import React from 'react';
import Button from 'components/Core/Button';
import { Normal, H6 } from 'components/Core/Typography';
import ToolboxSplashFiltersList from '../List/ToolboxSplashFiltersList';
import closeIcon from 'images/close-icon.png';

import { Container } from './styles';

const ToolboxSplashFiltersMobile = ({
  filters,
  handleListItemClick,
  hasSelectedFilters,
  clearFilters,
  isSelected,
  handleFilterButtonClick,
}) => (
  <Container>
    <div className="toolbox-details-filters-mobile--container">
      <H6
        className="toolbox-details-filters-mobile--clear-filters"
        onClick={() => handleFilterButtonClick('close')}
      >
        <img src={closeIcon} className="toolbox-details-filters-mobile--close-icon" />
      </H6>
      <Normal
        className="toolbox-details-filters-mobile--clear-filters"
        onClick={() => clearFilters()}
      >
        Clear all
      </Normal>
    </div>
    <ToolboxSplashFiltersList
      filters={filters}
      handleListItemClick={handleListItemClick}
      isSelected={isSelected}
    />
    <div className="toolbox-details-filters-mobile--apply-filter">
      <Button
        type="primary"
        width="calc(100% - 90px)"
        shadow={false}
        disabled={!hasSelectedFilters}
        onClick={() => handleFilterButtonClick('close')}
      >
        Apply Filter
      </Button>
    </div>
  </Container>
);

export default ToolboxSplashFiltersMobile;
